/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface UnassignUserFromConferences$Request {
    userId: number;
    requestBody: Array<number>;
}

export interface UnassignUserFromConferences$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const unassignUserFromConferencesRequest = createAction<PayloadData<void, UnassignUserFromConferences$Request>>('USER_CONFERENCES__UNASSIGN_USER_FROM_CONFERENCES__REQUEST');
export const unassignUserFromConferencesSuccess = createAction<PayloadData<void, UnassignUserFromConferences$Request>>('USER_CONFERENCES__UNASSIGN_USER_FROM_CONFERENCES__SUCCESS');
export const unassignUserFromConferencesFailure = createAction<PayloadData<Error, UnassignUserFromConferences$Request, true>>('USER_CONFERENCES__UNASSIGN_USER_FROM_CONFERENCES__FAILURE');

export const unassignUserFromConferencesActions = [
    unassignUserFromConferencesRequest,
    unassignUserFromConferencesSuccess,
    unassignUserFromConferencesFailure
] as const;

/**
 * @param {number} meta.userId The conference id
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const unassignUserFromConferences = (meta: UnassignUserFromConferences$Request, config?: UnassignUserFromConferences$Config) => {
    return {
        CALL_API: {
            types: unassignUserFromConferencesActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/users/${meta.userId}/conferences`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

